const BASE_URL = location.origin;

export const environment = {
  production: true,
  BASE_URL: BASE_URL,
  API_URL: BASE_URL,
  IMAGES_URL: BASE_URL,
  ASSETS_URL: BASE_URL + '/assets/',
  ANALYTICS_ID: 'UA-136147931-1',
  ANALYTICS4_ID: 'G-QNPTVK5D2L',
  EXTERNAL_BASE_URL: BASE_URL + '/v2/home', // Angular 13
  INACTIVITY_MINUTES: 15
};




// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/environments/environment.prod.ts